"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var CardSubFooter = function CardSubFooter(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "pp-parent-card-title"
  }, children);
};

var _default = CardSubFooter;
exports["default"] = _default;